import React from "react";
import "./social.css";
import icons from "../../icons";
export default function SocialMedia() {
  return (
    <div className="social">
      <h2>تواصل معي</h2>
      <div>
        {icons.map((item) => (
          <a
            style={{ maxWidth: "100px" }}
            key={item.id}
            href={item.link}
            target="_blank"
            rel="noreferrer"
          >
            <img src={item.img} alt="social media icon" />
          </a>
        ))}
      </div>
    </div>
  );
}
